import { createApi } from "@reduxjs/toolkit/query/react";

import { createCustomFetchBaseQuery } from "../baseQuery";


export const metricApi = createApi({
    reducerPath: "metric",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['Metric'],
    endpoints: (builder) => ({
        getAllMetrics: builder.query({

            query: ({ pageno, role, search ,dropdown ,sortOrder , sortBy, limit}) => {
                let url = `${role}/metrics?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`
                }
                if(dropdown){
                    url += `&dropdown=true`
                }
                if(sortBy){
                    url += `&sortBy=${sortBy}`
                }
                if(sortOrder){
                    url += `&sortOrder=${sortOrder}`
                }
                if(limit){
                    url += `&limit=${limit}`
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ['Metric'],
        }),
        addMetric: builder.mutation({
            query: ({ data, role , url }) => ({
                url: url,
                method: "POST",
                body: data
            }),
            invalidatesTags: ['Metric'],
        }),
        updateMetric: builder.mutation({
            query: ({ id, data, role ,url }) => ({
                url: url,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['Metric'],
        }),
        deleteMetric: builder.mutation({
            query: ({id, role}) => ({
                url: `${role}/metric/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ['Metric'],
        }),
        getDefaultMetrics: builder.query({
            query: () => {
                let url = `contractor/metrics/default`;
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ['Metric'],
        })

    })
});

export const {
    useGetAllMetricsQuery,
    useAddMetricMutation,
    useUpdateMetricMutation,
    useDeleteMetricMutation,
    useGetDefaultMetricsQuery
} = metricApi;

